import gql from 'graphql-tag';

// Multilingual v3: a language leaves the project. Its page translations stay stored and come back when it is added again.
export default gql`
mutation deleteProjectLanguage($projectLanguageId: Int!) {
  delete_project_languages_by_pk(project_language_id: $projectLanguageId) {
    project_language_id
  }
}
`;
